import { createReducer, on } from '@ngrx/store';
import { deleteFacebookButton, facebookButtonsFormUpdated , resetButtonTextState} from '../Actions/facebook-buttons.actions';
import { initialFacebookButtonsState } from '../State/facebook-buttons.state';


export const facebookButtonsReducer = createReducer(
  initialFacebookButtonsState,

  on(facebookButtonsFormUpdated, (state, { valid, dataTosave, dirty, buttonshow }) => ({
    ...state,
    formEventChildData: {
      valid,
      dirty,
      buttonshow,
      dataTosave: dataTosave ? dataTosave.map((b: any) => ({ ...b })) : []
    }
  })),
  on(deleteFacebookButton, (state, { index }) => ({
    ...state,
    formEventChildData: state.formEventChildData
      ? {
          ...state.formEventChildData,
          dataTosave: state.formEventChildData.dataTosave.filter((_, i) => i !== index)
        }
      : null
  })),
  on(resetButtonTextState, state => ({
    ...state,
    formEventChildData: null
  }))
);
